export const endpoint = {
    api: process.env.REACT_APP_API_URL,
};
